import ReactDOM from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import { store } from 'src/app/store';
import reportWebVitals from 'src/reportWebVitals';
import i18n, { initI18Next } from './lib/translation/i18n';
import App from './pages/App';
import './styles/globals.css';
import { injectStore } from './utils/orderStore';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

injectStore(store);
// inject store instance for using it in any code files avoiding circular dependencies

let persistor = persistStore(store);

const onBeforeLift = async () => {
  await initI18Next();
};

root.render(
  <Provider store={store}>
    <PersistGate
      loading={null}
      persistor={persistor}
      onBeforeLift={onBeforeLift}>
      <I18nextProvider i18n={i18n}>
        <App />
      </I18nextProvider>
    </PersistGate>
  </Provider>,
);

reportWebVitals();
